angular.module('picmonicng').directive('plsBrowseMoreMenu', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        options: '=',
      },
      template:
        '<div class="pls-browse-more-menu">' +
        // Card Actions
        '<picmonic-options ng-if="options.picmonic" location="serp" card="options.picmonic" sharing="true" from-playlist="playlist" playlist-picmonics="options.playlistPicmonics" class="pull-right left m-r-1"></picmonic-options>' +
        '<add-to-playlist ng-if="options.picmonic" picmonic="options.picmonic" class="pull-right"></add-to-playlist>' +
        // Pathway Actions
        '<picmonic-options ng-if="!options.picmonic && !options.pathway.track_id" location="serp" pathway="options.pathway" sharing="true" from-playlist="options.playlist" class="pull-right left m-r-1"></picmonic-options>' +
        // Track Actions
        '<picmonic-options ng-if="!options.picmonic && options.pathway.track_id" location="serp" track="options.pathway" sharing="true" from-playlist="options.playlist" class="pull-right left m-r-1"></picmonic-options>' +
        '</div>',
      controller: [
        '$scope',
        '$filter',
        'UserService',
        'LearnService',
        function ($scope, $filter, MarketOptionsConfig, UserService, LearnService) {
          $scope.LearnService = LearnService;
          $scope.UserService = UserService;
        },
      ],
      link: function (scope, element, attrs) {},
    };
  },
]);
